import { defineMessages } from 'react-intl-next';
export var contextPanelMessages = defineMessages({
  panelLabel: {
    id: 'fabric.editor.contextPanel.panelLabel',
    defaultMessage: 'Context panel',
    description: 'Label for the context panel'
  }
});